import * as React from "react";
const SvgSurfaceGraining = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.932 66.17H120.95", style: {
  fill: "green",
  stroke: "#007f00",
  strokeWidth: 3.16100001,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "18.96600008,18.96600008",
  strokeDashoffset: 0,
  strokeOpacity: 1
} }));
export default SvgSurfaceGraining;
